module.exports = __webpack_public_path__ + "static/media/menu_estoque.f40a3d9d.png";